import React from "react";
import { Link } from "react-router-dom";
import { products, formatNaira } from "../productsData";

function MerchCard({ item }) {
  return (
    <Link to={`/shop/${item.slug}`} className="track-card-link">
      <div className="merch-card">
        <div className="merch-thumb">
          {item.isNew && <span className="merch-badge-new">New</span>}
          <img src={item.images[0]} alt={item.name} />
        </div>
        <div className="merch-body">
          <div className="merch-name">{item.name}</div>
          <div className="merch-size">{item.sizes.join(" · ")}</div>
          <div className="merch-price">{formatNaira(item.price)}</div>
          <span className="btn-mu-dark d-block text-center">View Product</span>
        </div>
      </div>
    </Link>
  );
}

export default function Merch() {
  const featured = products.slice(0, 4);

  return (
    <section className="mu-section" id="shop">
      <div className="container">
        <div className="section-head-row">
          <div>
            <div className="mu-eyebrow">Merch</div>
            <h2 className="section-title">Official Merchandise</h2>
            <p className="section-sub">
              Support your favorite artists with exclusive apparel, accessories, and
              limited-edition collectibles.
            </p>
          </div>
          <Link to="/shop" className="btn-mu-outline">Shop Now &rarr;</Link>
        </div>

        <div className="row g-4">
          {featured.map((m) => (
            <div className="col-6 col-lg-3" key={m.slug}>
              <MerchCard item={m} />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
